<template>
  <div class="calculationDetail">
    <div class="repaymentPlan_bck">
      <img src="../../../assets/images/default-calculator-jiekuan.png" alt />
    </div>
    <div class="summary font14">
      <div class="mb10 top-money">￥{{ $tools._toFixed(amount, 2) }}</div>
      <div class="mb30 lixi">
        <p>本金(元):{{ form.aslnAmt }}</p>
        <p>利息(元):{{ $tools._toFixed(interest, 2) }}</p>
      </div>
      <div>
        <p class="message">年利率:{{ $tools._toFixed(form.bankRate) }}%</p>
        <p class="message">{{ form.rpayMth }}</p>
        <p class="message">可提前还款</p>
      </div>
    </div>
    <ul class="repay_list font14">
      <li v-for="item in tableList" :key="item.id">
        <!-- <div>
          <p>{{ item.decCnt }}/{{ ttlPeriod }}期 {{ item.acctBal }}</p>
          <p>本金：￥{{ item.lnBal }}</p>
        </div>
        <div>
          <p>还款日期：{{ $tools.date2Str(item.rpayDat, 'YYYY-MM-DD') }}</p>
          <p>利息：{{ item.intAll }}</p>
        </div> -->
        <div class="repay-top">
          <p>￥{{ item.termRfnAmt }}</p>
          <p>{{ item.decCnt }}/{{ ttlPeriod }}期</p>
        </div>
        <div class="repay-other">
          <span style="padding-right: 10px">本金：{{ item.lnBal }}</span>
          <span>利息：{{ item.intAll }}</span>
        </div>
        <div class="repay-other">
          <p>还款日期：{{ $tools.date2Str(item.rpayDat, 'YYYY-MM-DD') }}</p>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { getRepaymentPlan } from '@/api/calculator'
export default {
  data() {
    return {
      tableList: [],
      ttlPeriod: 0,
      amount: 0, // 还款总金额
      interest: 0, // 利息
      form: {
        aslnAmt: 10000,
        intDay: '21',
        bankRate: '10',
        term: 6,
        termType: 'M',
        rpayMth: 2,
      },
      repayMthOptions: [
        { value: '4', text: '按月付息、到期还本' },
        { value: '1', text: '等额本息' },
        { value: '2', text: '等额本金' },
      ],
    }
  },
  created() {
    this.calculate()
  },
  methods: {
    async calculate() {
      this.form = this.$route.query
      const params = {
        ...this.form,
      }
      if (this.form.rpayMth != null) {
        params.rpayMth = this.repayMthOptions.find(
          (item) => item.text === this.form.rpayMth
        ).value
      }
      params.term =
        this.form.term.indexOf('月') !== -1
          ? parseInt(this.form.term)
          : parseInt(this.form.term) * 12
      params.intDay = this.form.intDay.match(/\d+/)[0]
      const res = await getRepaymentPlan(params)
      if (res && res.list && res.list.length > 0) {
        this.tableList = res.list
        this.ttlPeriod = res.ttlPeriod
        this.interest = res.intTmttl
        this.amount = Number(this.interest) + Number(this.form.aslnAmt)
        console.log(this.amount)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.calculationDetail {
  padding-top: 75px;
  padding-bottom: 75px;
  position: relative;
  .repaymentPlan_bck {
    position: absolute;
    z-index: -1;
    top: 0;
    img {
      width: 100%;
      height: 160px;
    }
  }
  .summary {
    box-shadow: 0 0.04rem 0.16rem 0.04rem rgba(0, 0, 0, 0.05);
    background: #fff;
    color: #000;
    margin: 10px 20px;
    margin-top: 0;
    padding: 20px;
    border-radius: 8px;
    .top-money {
      font-size: 28px;
      font-weight: bold;
      line-height: 28px;
    }
    .lixi {
      color: #888888;
      font-size: 12px;
    }
    .message {
      background: rgba(9, 18, 43, 0.05);
      color: black;
    }
    div {
      &:first-of-type {
        text-align: center;
      }
      &:not(:first-of-type) {
        display: flex;
        justify-content: space-between;
      }
    }
  }
  .repay_list {
    background: #fff;
    li {
      //border-bottom: 1px solid #ccc;
      padding: 15px 20px;
      line-height: 1.5;
      position: relative;
      &::after {
        position: absolute;
        background: #ebedf0;
        bottom: 0;
        height: 1px;
        width: 90%;
        content: '';
        left: 50%;
        transform: translateX(-50%);
      }
      div.repay-top {
        display: flex;
        justify-content: space-between;
        p:first-child {
          font-size: 18px;
          color: #09122b;
        }
        p:last-child {
          font-size: 15px;
          color: #888888;
        }
      }
      div.repay-other {
        color: #c1c1c1;
        font-size: 15px;
      }
    }
  }
}
</style>
